module.exports = __webpack_public_path__ + "static/media/card-bg.e2a277ec.svg";